import { Component } from 'react';
import PropTypes from 'prop-types';
import contentOutputs from '../prosemirror/editorCapabilities/ContentOutputTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default ((ContentComponent, {
  outputType,
  apiFunctions
}) => {
  var _class;
  return _class = class extends Component {
    constructor(...args) {
      super(...args);
      this.insertContent = ({
        id,
        htmlBody,
        offset,
        length,
        version
      }) => {
        return outputType !== contentOutputs.EDITABLE ? this.getRenderedContent({
          id,
          offset,
          length,
          version
        }) : this.getUnrenderedContent({
          id,
          htmlBody,
          offset,
          length
        });
      };
      this.getUnrenderedContent = ({
        id,
        htmlBody,
        offset,
        length
      }) => {
        if (htmlBody) {
          this.updateEditorState({
            htmlBody,
            offset,
            length
          });
        }
        return apiFunctions.fetchUnrenderedContent({
          id
        })
        // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'fetchedHtmlBody' implicitly has a... Remove this comment to see the full error message
        .then(({
          htmlBody: fetchedHtmlBody
        }) => {
          this.updateEditorState({
            offset,
            length,
            htmlBody: fetchedHtmlBody
          });
        });
      };
      this.getRenderedContent = ({
        id,
        offset,
        length,
        version
      }) => {
        return apiFunctions.fetchRenderedContent(Object.assign({
          id,
          version
        }, this.props)).then(({
          body,
          htmlBody,
          metadata
        }) => {
          const selectedBody = outputType === contentOutputs.RENDERED ? htmlBody : body;
          this.updateEditorState({
            offset,
            length,
            htmlBody: selectedBody,
            metadata
          });
        });
      };
      this.updateEditorState = ({
        htmlBody,
        metadata
      }) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
        const {
          onChange
        } = this.props;
        onChange({
          htmlBody,
          metadata
        });
      };
    }
    render() {
      return /*#__PURE__*/_jsx(ContentComponent, Object.assign({}, this.props, {
        insertContent: this.insertContent
      }));
    }
  }, _class.propTypes = {
    editorState: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    contactEmail: PropTypes.string,
    contactVid: PropTypes.number,
    defaultStyle: PropTypes.object,
    objectType: PropTypes.string,
    subjectId: PropTypes.string,
    useProsemirror: PropTypes.bool
  }, _class;
});